import { t } from "@lingui/macro";
import { type WithIdProps, withId } from "@src/components/HOC/with-id/withId";
import { EditQuotePage } from "@src/components/modules/budgets/edit-quote";
import { NavigationQuote } from "@src/components/widgets/AppSubNav/navigation-quote";
import { MainLayout } from "@src/components/widgets/Layout";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => {
  return (
    <MainLayout
      fullWidth
      title={t`Edit Quote`}
      navigation={<NavigationQuote id={id} />}
    >
      <EditQuotePage id={id} />
    </MainLayout>
  );
};

const RouteComponent = withId(Page);

export const Route = createFileRoute("/budgets/edit-quote")({
  component: RouteComponent,
});
